import { Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import {
  ABOVE_GROUND_POOL_STEP_COUNT,
  IN_GROUND_POOL_STEP_COUNT,
  NO_POOL_STEP_COUNT,
  PropertyType,
} from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import { PropertyUpload } from "../property-upload";
import styles from "./property-update-pool.module.scss";

export const PoolProofUpload = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext
    );

  let totalSteps = NO_POOL_STEP_COUNT;
  if (state?.poolType === "In-ground") {
    totalSteps = IN_GROUND_POOL_STEP_COUNT;
  } else if (state?.poolType === "Above-ground") {
    totalSteps = ABOVE_GROUND_POOL_STEP_COUNT;
  }

  const noPool = state?.poolType === "None";
  // This is the last step unless poolType === "None"
  const step = noPool ? totalSteps - 1 : totalSteps;

  return (
    <MultiStepFormLayout
      step={step}
      totalSteps={totalSteps}
      heading="Help us review the details"
      buttonProps={{
        primary: {
          disabled: !state?.files?.length,
          path: noPool ? "../confirm" : "../review",
          text: "Next",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <div className={styles.poolProof}>
        <Span>
          Please upload photos of your pool. Include the surrounding gate,
          fence, and locks if available.
        </Span>
        <PropertyUpload
          filesField="files"
          propertyType={PropertyType.pool}
          state={state}
          setFields={setFields}
        />
      </div>
    </MultiStepFormLayout>
  );
};
